import $ from "jquery";
import "slick-carousel";

$(".testimonial-slider .slides").slick({
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000
});
